import { NgModule } from 'ng-metadata/core';
import { mdChipsProvider } from './md-chips-provider.config';
import './chips.scss';

/**
 * @ngdoc module
 * @name mw.components.chips
 * @description
 *
 * Chips
 */
@NgModule({
    providers: [mdChipsProvider]
})
export class ChipsModule {}



// WEBPACK FOOTER //
// ./src/lib/components/chips/chips.module.ts